import React, {useState} from 'react';
import {Button, FormControlLabel, Switch} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import {
    CancelNotice,
    DiscountBadge,
    FeatureItem,
    FeaturesList,
    PaymentInfoBox,
    PaymentMethodsList,
    PaymentTitle,
    PopularBadge,
    PriceAmount,
    PriceBox,
    PricePeriod,
    SectionSubtitle,
    SectionTitle,
    TariffCard,
    TariffName,
    TariffPosts,
    TariffsGrid,
    ToggleContainer,
    Wrapper,
} from './styles';
import {useLandingContext} from "../../../Landing";

export default function Tariffs({onOpenTrial}) {
    const {APP_DATA} = useLandingContext();

    const [isAnnual, setIsAnnual] = useState(false);

    return (
        <Wrapper id="tariffs-section">
            <SectionTitle>{APP_DATA.tariffsTitle}</SectionTitle>
            <SectionSubtitle>{APP_DATA.tariffsSubTitle}</SectionSubtitle>

            <ToggleContainer>
                <span>{APP_DATA.month}</span>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isAnnual}
                            onChange={(e) => setIsAnnual(e.target.checked)}
                            color="primary"
                        />
                    }
                    label=""
                    style={{margin: 0}}
                />
                <span>
          {APP_DATA.year} <DiscountBadge>{APP_DATA.tariffsDiscount}</DiscountBadge>
        </span>
            </ToggleContainer>

            <TariffsGrid>
                {APP_DATA.tariffs.map((tariff) => {
                    const price = isAnnual ? tariff.priceAnnual : tariff.priceMonthly;
                    return (
                        <TariffCard key={tariff.id} $popular={tariff.popular}>
                            {tariff.popular && <PopularBadge>{APP_DATA.tariffSelected}</PopularBadge>}
                            <TariffName>{APP_DATA.tariffTitle} {tariff.name}</TariffName>
                            <TariffPosts>{tariff.posts}</TariffPosts>
                            <PriceBox>
                                <PriceAmount>{price.toLocaleString('ru-RU')} ₽</PriceAmount>
                                <PricePeriod>/ {isAnnual ? APP_DATA.tariffsAnnual : APP_DATA.tariffsMonth}</PricePeriod>
                            </PriceBox>
                            <FeaturesList>
                                {tariff.features.map((feat, idx) => (
                                    <FeatureItem key={idx}>
                                        <CheckCircleIcon color="primary" sx={{fontSize: 16}}/>
                                        {feat}
                                    </FeatureItem>
                                ))}
                            </FeaturesList>
                            <Button
                                variant={tariff.popular ? 'contained' : 'outlined'}
                                color="primary"
                                onClick={() => onOpenTrial(tariff.id)}
                                style={{
                                    borderRadius: 12,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    padding: '10px',
                                }}
                            >
                                {APP_DATA.cta}
                            </Button>
                        </TariffCard>
                    );
                })}
            </TariffsGrid>

            <PaymentInfoBox>
                <PaymentTitle>{APP_DATA.methodsTitle}</PaymentTitle>
                <PaymentMethodsList>
                    {APP_DATA.methods.map(method => (
                        <div key={method.desc} style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                            <CreditCardIcon fontSize="small" color="action"/>
                            {method.desc}
                        </div>
                    ))}
                </PaymentMethodsList>
                <CancelNotice>{APP_DATA.cancelNotice}</CancelNotice>
            </PaymentInfoBox>
        </Wrapper>
    );
}
